





















import { Component, Mixins } from "vue-property-decorator";
import { ReferenceFileViewMixin } from "../../../../document/mixins";
import ExistingDocumentViewer from "../../../viewers/ExistingDocumentViewer.vue";
import DocumentArchiveIndicator from "../../../selectors/wizard/guest/DocumentArchiveIndicator.vue";
import DocumentArchiveSelector from "../../../selectors/DocumentArchiveSelector.vue";
import { DocumentViewMixin } from "../../../mixins";

@Component({
  components: {
    ExistingDocumentViewer,
    DocumentArchiveSelector,
    DocumentArchiveIndicator,
  }
})
export default class DocumentViewer extends Mixins(DocumentViewMixin, ReferenceFileViewMixin) {
}
